import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
export function useMultiFilter(args) {
    const [toggleMultiListFilterItemMutation] = useMutation(gql `
    mutation toggleMultiListItem {
      toggleMultiListFilterItem(
        value: $value
        filter: $filter
        listIndex: $listIndex
      ) @client {
        isActive @client
      }
    }
  `);
    /** Applies a value at the given listIndex */
    function apply({ value, listIndex }) {
        const filter = args.filter;
        return toggleMultiListFilterItemMutation({
            variables: {
                filter,
                listIndex,
                value
            }
        });
    }
    const [clearMultiListFilterListMutation] = useMutation(gql `
    mutation ClearMultiList {
      clearMultiListFilterList(listIndex: $listIndex, filter: $filter) @client
    }
  `);
    /** Clears a specific list of the filter */
    function clearList({ listIndex }) {
        return clearMultiListFilterListMutation({
            variables: { listIndex, filter: args.filter }
        });
    }
    const [clearMultiListFilterMutation] = useMutation(gql `
    mutation ClearMultiFilter {
      clearMultiListFilter(id: $id) @client
    }
  `);
    /** Clears the entire list filter, resetting it */
    function clearFilter() {
        return clearMultiListFilterMutation({
            variables: { id: args.filter.id }
        });
    }
    return { apply, clearList, clearFilter };
}
//# sourceMappingURL=useMultiFilter.js.map